import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgNurseMale1 = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 6.495C16.2755 7.15971 16.3828 7.88212 16.3124 8.5982C16.2419 9.31429 15.996 10.0019 15.5963 10.6003C15.1966 11.1986 14.6555 11.6891 14.0209 12.0283C13.3863 12.3675 12.6779 12.545 11.9584 12.545C11.2388 12.545 10.5304 12.3675 9.89584 12.0283C9.26128 11.6891 8.72017 11.1986 8.32047 10.6003C7.92077 10.0019 7.67481 9.31429 7.60438 8.5982C7.53395 7.88212 7.64123 7.15971 7.91671 6.495"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.58 21.375V14.4442"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.57996 18.7942H10.08"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.82996 17.5442V20.0442"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.08 4.5C10.08 4.99728 10.2775 5.47419 10.6291 5.82582C10.9808 6.17746 11.4577 6.375 11.955 6.375C12.4522 6.375 12.9292 6.17746 13.2808 5.82582C13.6324 5.47419 13.83 4.99728 13.83 4.5C13.83 4.00272 13.6324 3.52581 13.2808 3.17417C12.9292 2.82254 12.4522 2.625 11.955 2.625C11.4577 2.625 10.9808 2.82254 10.6291 3.17417C10.2775 3.52581 10.08 4.00272 10.08 4.5V4.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58081 8.25H16.3291"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9867 21.375C19.7078 19.4438 18.7423 17.6777 17.2673 16.4004C15.7922 15.1231 13.9063 14.42 11.955 14.42C10.0037 14.42 8.11782 15.1231 6.64276 16.4004C5.16769 17.6777 4.20226 19.4438 3.92334 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgNurseMale1.displayName = 'SvgNurseMale1';
export default SvgNurseMale1;
